// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2d79i","top":"styles_top__2zc3T","left":"styles_left__3fKyu","description":"styles_description__1aPB9"};